export default __webpack_public_path__ + "static/4-1ace4bade1ccb8dc70ac6a8fc0188f86.svg";